import LegalLayout from "@/components/LegalLayout";

export default function TermsConditions() {
    return (
        <LegalLayout
            testId="terms-conditions-page"
            title="Terms & Conditions"
            effectiveDate="02-02-2024"
        >
            <p>
                Thank you for choosing FilesCAD! These Terms and Conditions outline the rules and regulations for the use of our mobile application and website. By accessing or using FilesCAD, you agree to abide by these terms. If you do not agree with any part of these terms, please do not use our services.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">1. Acceptance of Terms</h3>
            <p>
                By using FilesCAD, you acknowledge that you have read, understood, and agree to these Terms and Conditions. If you are using FilesCAD on behalf of a company or organization, you also represent that you have the authority to bind them to these terms.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">2. Use of Services</h3>
            <p>
                FilesCAD grants you a limited, non-exclusive, non-transferable, and revocable license to use our services for personal or commercial purposes. You agree to comply with all applicable laws and regulations during your use of FilesCAD. Please read the license policy for a better understanding of file uses.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">3. User Accounts</h3>
            <p>
                To access certain features of FilesCAD, you may be required to register for an account, providing some information about yourself. For a better understanding, please read our privacy policy.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">4. Intellectual Property</h3>
            <p>
                All content and materials on FilesCAD, including but not limited to designs, text, graphics, logos, and software, are the property of FilesCAD.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">5. Payment and Transactions</h3>
            <p>
                When making purchases on FilesCAD, you agree to provide accurate billing and payment information. Transactions are processed securely, and you are responsible for any applicable taxes or fees associated with your purchases.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">6. User Conduct</h3>
            <p>You agree not to engage in any activity that may:</p>
            <ul className="list-decimal pl-6 space-y-1">
                <li>Violate any laws or regulations</li>
                <li>Infringe upon the rights of others</li>
                <li>Interfere with the operation of FilesCAD</li>
                <li>Harass, threaten, or harm others</li>
            </ul>
            <p>Please read our license policy for a better understanding of do&rsquo;s and don&rsquo;ts with our digital files.</p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">7. Termination</h3>
            <p>
                FilesCAD reserves the right to terminate or suspend your account and access to our services at any time, for any reason, without prior notice.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">8. Limitation of Liability</h3>
            <p>
                FilesCAD is not liable for any direct, indirect, incidental, special, or consequential damages arising out of or in any way connected with the use of our services.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">9. Governing Law</h3>
            <p>
                These Terms and Conditions are governed by and construed in accordance with the laws of India. Any disputes arising under or in connection with these terms shall be subject to the exclusive jurisdiction of the courts in Jodhpur, Rajasthan, India.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">10. Changes to Terms and Conditions</h3>
            <p>
                FilesCAD may update these Terms and Conditions from time to time. We will notify you of any material changes, and your continued use of our services after the effective date of the changes constitutes acceptance of the updated terms.
            </p>

            <h3 className="font-display font-bold text-2xl text-slate-950 mt-10">Contact Us</h3>
            <p>
                If you have any questions or concerns about these Terms and Conditions, please contact us at:{" "}
                <a
                    href="mailto:support@filescad.com"
                    data-testid="terms-contact-email"
                    className="text-blue-600 hover:underline font-semibold"
                >
                    support@filescad.com
                </a>
            </p>

            <p className="mt-8 italic text-slate-500">
                By using FilesCAD, you agree to these Terms and Conditions.
            </p>
        </LegalLayout>
    );
}
